<template>
  <div
      class="lg:sticky lg:top-0 lg:z-40 flex justify-center items-center gap-1 p-2 bg-darkPurpl hover:bg-mediumPurpl transition-colors text-center text-sm">
    <span class="font-semibold">Available for iOS</span>
    <a href="#" class="flex items-center font-light underline
            after:bg-[url(/public/stima/assets/images/icons/arrow-white.svg)] after:w-6 after:h-6">Discover</a>
  </div>
</template>